export default __webpack_public_path__ + "static/media/OpenTextBook.42bb8597a6ece56146bc58259cbb6762.webp";